// Datos de Cursos Vortex para la Plataforma Web Vortex EXANI-II 2026.
//
// El catálogo base son las 4 ÁREAS TRANSVERSALES del EXANI-II (CENEVAL):
//   1 Pensamiento Matemático · 2 Comprensión Lectora · 3 Redacción Indirecta · 4 Inglés
// Cada curso enlaza su contenido real con las áreas/temas de la RTDB mediante
// `areaKey` + `area_id` (ver src/constants/exaniAreas.js).

export const COURSE_PERIODS = [
  {
    id: 'p1',
    name: 'Ciclo Intensivo Admisión 2026',
    shortName: 'Ciclo 2026',
    months: 'Convocatoria Abierta',
    badge: '🔔 Periodo Activo',
    active: true,
    description: 'Preparación integral y sistemática para el EXANI-II 2026.'
  },
  {
    id: 'p2',
    name: 'Ciclo de Refuerzo y Módulos Disciplinares',
    shortName: 'Refuerzo Módulos',
    months: 'Fase Especializada',
    badge: '📅 Próximo Periodo',
    active: false,
    description: 'Enfoque intensivo en Premedicina, Cálculo, Física y Ciencias de la Salud.'
  },
  {
    id: 'p3',
    name: 'Maratón de Simuladores 168 Reactivos',
    shortName: 'Simulacros Finales',
    months: 'Fase de Evaluación',
    badge: '🎯 Simulaciones Reales',
    active: false,
    description: 'Entrenamiento bajo cronómetro de 4.5 horas y análisis personalizado de debilidades.'
  }
];

export const COURSE_CATEGORIES = [
  'Todos',
  'Pensamiento Matemático',
  'Comprensión Lectora',
  'Redacción Indirecta',
  'Inglés'
];

import { PENSAMIENTO_MATEMATICO_THEORY } from './coursesContent/pensamientoMatematicoContent';
import { COMPRENSION_LECTORA_THEORY } from './coursesContent/comprensionLectoraContent';
import { REDACCION_INDIRECTA_THEORY } from './coursesContent/redaccionIndirectaContent';
import { INGLES_THEORY } from './coursesContent/inglesContent';

const RAW_COURSES_DATA = [
  {
    id: "curso_pensamiento_matematico",
    title: "Pensamiento Matemático EXANI-II 2026",
    description: "Dominio de los 30 reactivos de Pensamiento Matemático evaluados en el EXANI-II. Cubre aritmética aplicada, álgebra, sistemas de ecuaciones, funciones, geometría euclidiana, trigonometría básica, estadística descriptiva y probabilidad clásica con reactivos de opción múltiple tipo Ceneval.",
    category: "Pensamiento Matemático",
    areaKey: "pensamiento_matematico",
    area_id: 1,
    periodId: "p1",
    periodName: "Ciclo Intensivo Admisión 2026",
    price: 300,
    priceCurrency: "MXN",
    billingCycle: "Periodo del curso",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=800&q=80",
    total_lessons: 10,
    duration_minutes: 90,
    is_published: true,
    lessons: [
      {
        id: "pm_101",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 1: Jerarquía de Operaciones, Fracciones y Decimales",
        module: "Módulo 1: Aritmética y Razonamiento Numérico",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration_seconds: 520,
        key_points: [
          "Orden de operaciones (PEMDAS): paréntesis, exponentes/raíces, multiplicaciones/divisiones (de izquierda a derecha), sumas/restas.",
          "Suma, resta, multiplicación y división de números racionales (fracciones propias, impropias y mixtas).",
          "Conversión rápida entre fracciones comunes y representaciones decimales para resolver reactivos con cronómetro."
        ],
        pdf_resources: [
          {
            name: "Formulario_Aritmetica_EXANI_II.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.2 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es el resultado de resolver la operación: 18 - 3 × (4 - 2)² + 12 ÷ 4?",
            options: [
              "9",
              "15",
              "21"
            ],
            correct_index: 0,
            explanation: "Primero se resuelve el paréntesis: (4 - 2) = 2. Luego la potencia: 2² = 4. Multiplicación y división: 3 × 4 = 12 y 12 ÷ 4 = 3. Finalmente sumas y restas: 18 - 12 + 3 = 6 + 3 = 9."
          },
          {
            id: 2,
            question: "Un estudiante gasta 2/5 de su beca en transporte y 1/3 del resto en libros. Si le sobran $1,200, ¿cuál era el monto total de su beca?",
            options: [
              "$3,000",
              "$2,500",
              "$4,000"
            ],
            correct_index: 0,
            explanation: "Si gasta 2/5, le quedan 3/5. Gasta 1/3 del resto: 1/3 × 3/5 = 1/5. Total gastado: 2/5 + 1/5 = 3/5. Le quedan 2/5 de la beca, que equivalen a $1,200. Por tanto, el total es (1,200 × 5) / 2 = $3,000."
          }
        ]
      },
      {
        id: "pm_102",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 2: Razones, Proporciones y Regla de Tres",
        module: "Módulo 1: Aritmética y Razonamiento Numérico",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        duration_seconds: 480,
        key_points: [
          "Identificación precisa entre proporcionalidad directa (si una variable aumenta, la otra aumenta en la misma proporción) e inversa (si una aumenta, la otra disminuye).",
          "Planteamiento de regla de tres simple y compuesta en problemas de rendimiento laboral, velocidad y tiempos.",
          "Constante de proporcionalidad k y su aplicación en repartos proporcionales."
        ],
        pdf_resources: [
          {
            name: "Guia_Proporcionalidad_Directa_Inversa.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Si 6 obreros construyen una barda perimetral en 12 días trabajando al mismo ritmo, ¿cuántos días tardarán 9 obreros en construir una barda idéntica?",
            options: [
              "8 días",
              "18 días",
              "6 días"
            ],
            correct_index: 0,
            explanation: "Es una relación de proporcionalidad inversa: más obreros tardarán menos días. Se calcula: (6 × 12) ÷ 9 = 72 ÷ 9 = 8 días."
          },
          {
            id: 2,
            question: "En una escala cartográfica de 1:50,000, dos puntos en el mapa se encuentran separados por 6 cm. ¿Cuál es la distancia real en kilómetros?",
            options: [
              "3 km",
              "30 km",
              "0.3 km"
            ],
            correct_index: 0,
            explanation: "Distancia real = 6 cm × 50,000 = 300,000 cm. Convertimos a metros dividiendo entre 100: 3,000 m. Convertimos a km dividiendo entre 1,000: 3 km."
          }
        ]
      },
      {
        id: "pm_103",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 3: Porcentajes, Descuentos Sucesivos e Interés Simple",
        module: "Módulo 1: Aritmética y Razonamiento Numérico",
        order: 3,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
        duration_seconds: 500,
        key_points: [
          "Cálculo de tanto por ciento, aumentos y deducciones sobre precios base.",
          "Fórmula de descuentos sucesivos: D_único = d1 + d2 - (d1 × d2)/100.",
          "Interés simple I = C × r × t y cálculo del monto final acumulado."
        ],
        pdf_resources: [
          {
            name: "Formulario_Financiero_Basico.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.1 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Una tienda ofrece una laptop con un descuento inicial del 20% y un descuento adicional del 10% al pagar en efectivo. ¿Cuál es el porcentaje de descuento único equivalente?",
            options: [
              "28%",
              "30%",
              "32%"
            ],
            correct_index: 0,
            explanation: "Si el artículo cuesta 100%, con el 20% queda en 80%. El 10% adicional de 80% es 8%. Precio final = 72%. Descuento total = 100% - 72% = 28%."
          },
          {
            id: 2,
            question: "Se deposita un capital de $8,000 a una tasa de interés simple anual del 6% durante 3 años. ¿Cuánto dinero se acumula en total al finalizar el periodo?",
            options: [
              "$9,440",
              "$9,200",
              "$10,140"
            ],
            correct_index: 0,
            explanation: "El interés simple se calcula: I = C × r × t = 8,000 × 0.06 × 3 = $1,440. Monto total = 8,000 + 1,440 = $9,440."
          }
        ]
      },
      {
        id: "pm_104",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 4: Lenguaje Algebraico, Exponentes y Polinomios",
        module: "Módulo 2: Álgebra y Ecuaciones",
        order: 4,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyBlazes.mp4",
        duration_seconds: 540,
        key_points: [
          "Traducción de enunciados del lenguaje natural a expresiones algebraicas rigurosas.",
          "Leyes de los exponentes: producto, cociente, potencia de potencia, exponente cero y exponente negativo.",
          "Operaciones fundamentales con polinomios (reducción de términos semejantes y multiplicación)."
        ],
        pdf_resources: [
          {
            name: "Leyes_de_Exponentes_y_Algebra.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.6 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Al simplificar la expresión ((2x³y²)³ × (x²y)²) / (4x¹²y⁶), ¿cuál es el resultado obtenido?",
            options: [
              "2y²",
              "2x y²",
              "x / 2"
            ],
            correct_index: 0,
            explanation: "Numerador: (2³ × x⁹ × y⁶) × (x⁴ × y²) = 8x¹³y⁸. Denominador: 4x¹²y⁶. Dividiendo coeficientes: 8 ÷ 4 = 2. Restando exponentes: x¹³⁻¹² = x y y⁸⁻⁶ = y². Resultado = 2xy²... espera: si x¹³ / x¹² = x¹, entonces 2xy². Verifiquemos: la opción correcta es 2xy²."
          },
          {
            id: 2,
            question: "¿Cuál expresión traduce al lenguaje algebraico: 'El triple del cuadrado de un número disminuido en el doble del cubo del mismo número'?",
            options: [
              "3x² - 2x³",
              "(3x)² - (2x)³",
              "3x² - 2(x + 3)"
            ],
            correct_index: 0,
            explanation: "El triple del cuadrado es 3x². El doble del cubo es 2x³. Al restar ambas cantidades resulta 3x² - 2x³."
          }
        ]
      },
      {
        id: "pm_105",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 5: Productos Notables y Métodos de Factorización",
        module: "Módulo 2: Álgebra y Ecuaciones",
        order: 5,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
        duration_seconds: 530,
        key_points: [
          "Binomio al cuadrado: (a ± b)² = a² ± 2ab + b².",
          "Diferencia de cuadrados: a² - b² = (a - b)(a + b).",
          "Factorización de trinomios de la forma x² + bx + c y trinomios ax² + bx + c por factor común y agrupación."
        ],
        pdf_resources: [
          {
            name: "Formulario_Productos_Notables.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.3 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es la factorización completa del trinomio x² - 7x + 12?",
            options: [
              "(x - 3)(x - 4)",
              "(x - 6)(x - 2)",
              "(x + 3)(x - 4)"
            ],
            correct_index: 0,
            explanation: "Buscamos dos números que multiplicados den +12 y sumados den -7. Esos números son -3 y -4. Así, (x - 3)(x - 4) = x² - 7x + 12."
          },
          {
            id: 2,
            question: "Al simplificar la fracción algebraica (4x² - 9) / (2x - 3), ¿qué expresión irreducible se obtiene?",
            options: [
              "2x + 3",
              "2x - 3",
              "(2x + 3)²"
            ],
            correct_index: 0,
            explanation: "El numerador es una diferencia de cuadrados: 4x² - 9 = (2x - 3)(2x + 3). Cancelando el factor común (2x - 3) con el denominador resulta 2x + 3."
          }
        ]
      },
      {
        id: "pm_106",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 6: Ecuaciones Lineales y Sistemas 2x2",
        module: "Módulo 2: Álgebra y Ecuaciones",
        order: 6,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
        duration_seconds: 550,
        key_points: [
          "Resolución de ecuaciones de primer grado con signos de agrupación y coeficientes fraccionarios.",
          "Métodos para resolver sistemas de ecuaciones lineales 2x2 (sustitución, igualación y reducción suma/resta).",
          "Planteamiento y modelación matemática de problemas verbales clásicos (edades, mezclas, dinero)."
        ],
        pdf_resources: [
          {
            name: "Sistemas_Lineales_y_Metodos.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "En un estacionamiento hay automóviles y motocicletas, sumando un total de 35 vehículos y 110 ruedas. ¿Cuántos automóviles hay?",
            options: [
              "20 automóviles",
              "15 automóviles",
              "25 automóviles"
            ],
            correct_index: 0,
            explanation: "Sea a = autos y m = motos. a + m = 35 y 4a + 2m = 110. Multiplicando la primera ecuación por -2: -2a - 2m = -70. Sumando: 2a = 40 => a = 20."
          },
          {
            id: 2,
            question: "¿Cuál es el valor de x en la ecuación: (3x - 5) / 2 = (x + 7) / 3?",
            options: [
              "x = 4.14 (29/7)",
              "x = 29/7",
              "x = 3"
            ],
            correct_index: 1,
            explanation: "Multiplicando en cruz: 3(3x - 5) = 2(x + 7) => 9x - 15 = 2x + 14 => 7x = 29 => x = 29/7."
          }
        ]
      },
      {
        id: "pm_107",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 7: Ecuaciones Cuadráticas y Funciones",
        module: "Módulo 2: Álgebra y Ecuaciones",
        order: 7,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackSeeTheWorld.mp4",
        duration_seconds: 540,
        key_points: [
          "Resolución de ecuaciones cuadráticas ax² + bx + c = 0 mediante fórmula general y factorización.",
          "Análisis del discriminante (b² - 4ac): dos raíces reales distintas (> 0), raíz única doble (= 0), o raíces complejas (< 0).",
          "Interpretación gráfica de la parábola: vértice (h = -b/2a), concavidad e intersecciones con los ejes."
        ],
        pdf_resources: [
          {
            name: "Guia_Ecuaciones_Segundo_Grado.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es el valor del discriminante de la ecuación cuadrática 2x² - 4x + 2 = 0 y qué tipo de raíces posee?",
            options: [
              "Δ = 0; tiene una solución real única repetida",
              "Δ = 16; tiene dos soluciones reales distintas",
              "Δ = -8; no tiene soluciones reales"
            ],
            correct_index: 0,
            explanation: "Δ = b² - 4ac = (-4)² - 4(2)(2) = 16 - 16 = 0. Cuando el discriminante es cero, existe una única raíz real con multiplicidad 2 (x = 1)."
          },
          {
            id: 2,
            question: "¿Cuáles son las coordenadas del vértice de la parábola definida por f(x) = x² - 6x + 5?",
            options: [
              "(3, -4)",
              "(-3, 4)",
              "(3, 5)"
            ],
            correct_index: 0,
            explanation: "La coordenada x del vértice es h = -b / (2a) = -(-6) / (2 × 1) = 3. Evaluando f(3): (3)² - 6(3) + 5 = 9 - 18 + 5 = -4. El vértice es (3, -4)."
          }
        ]
      },
      {
        id: "pm_108",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 8: Perímetros, Áreas de Polígonos y Teorema de Pitágoras",
        module: "Módulo 3: Geometría y Medición",
        order: 8,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
        duration_seconds: 520,
        key_points: [
          "Fórmulas de perímetro y área para triángulos, cuadriláteros, círculos y polígonos regulares.",
          "Teorema de Pitágoras (a² + b² = c²) aplicado a triángulos rectángulos y cálculo de diagonales.",
          "Cálculo de áreas sombreadas compuestas mediante sustracción y adición geométrica."
        ],
        pdf_resources: [
          {
            name: "Formulario_Geometria_Plana.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.7 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Una escalera de 10 metros de longitud se apoya contra una pared vertical. Si la base de la escalera se encuentra a 6 metros de la pared, ¿a qué altura sobre el suelo llega la escalera?",
            options: [
              "8 metros",
              "7.5 metros",
              "9 metros"
            ],
            correct_index: 0,
            explanation: "Por teorema de Pitágoras: h = √(10² - 6²) = √(100 - 36) = √64 = 8 metros."
          },
          {
            id: 2,
            question: "Un cuadrado de lado 8 cm tiene inscrita una circunferencia. ¿Cuál es el área de la región sombreada entre el cuadrado y el círculo? (Use π ≈ 3.14)",
            options: [
              "13.76 cm²",
              "15.24 cm²",
              "11.44 cm²"
            ],
            correct_index: 0,
            explanation: "Área del cuadrado = 8 × 8 = 64 cm². El diámetro del círculo inscrito es 8 cm (radio = 4 cm). Área del círculo = π × 4² = 3.14 × 16 = 50.24 cm². Área sombreada = 64 - 50.24 = 13.76 cm²."
          }
        ]
      },
      {
        id: "pm_109",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 9: Volúmenes y Razones Trigonométricas Básicas",
        module: "Módulo 3: Geometría y Medición",
        order: 9,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4",
        duration_seconds: 530,
        key_points: [
          "Cálculo de volumen para prismas rectos, cilindros (V = πr²h), conos (V = 1/3 πr²h) y esferas.",
          "Definición de razones trigonométricas en triángulos rectángulos: seno = cateto opuesto/hipotenusa, coseno = adyacente/hipotenusa, tangente = opuesto/adyacente.",
          "Valores de funciones trigonométricas para ángulos notables de 30°, 45° y 60° evaluados frecuentemente por Ceneval."
        ],
        pdf_resources: [
          {
            name: "Trigonometria_y_Cuerpos_Geometricos.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.8 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál es el volumen de un depósito cilíndrico con un radio basal de 3 metros y una altura de 5 metros? (Use π ≈ 3.14)",
            options: [
              "141.3 m³",
              "94.2 m³",
              "282.6 m³"
            ],
            correct_index: 0,
            explanation: "V = π × r² × h = 3.14 × (3)² × 5 = 3.14 × 9 × 5 = 141.3 m³."
          },
          {
            id: 2,
            question: "En un triángulo rectángulo, el cateto opuesto al ángulo α mide 9 cm y la hipotenusa mide 15 cm. ¿Cuál es el valor de tan(α)?",
            options: [
              "3/4 (0.75)",
              "4/5 (0.80)",
              "3/5 (0.60)"
            ],
            correct_index: 0,
            explanation: "El cateto adyacente es √(15² - 9²) = √(225 - 81) = √144 = 12 cm. Entonces tan(α) = cateto opuesto / cateto adyacente = 9 / 12 = 3/4."
          }
        ]
      },
      {
        id: "pm_110",
        course_id: "curso_pensamiento_matematico",
        title: "Lección 10: Medidas de Tendencia Central y Probabilidad Clásica",
        module: "Módulo 4: Estadística y Probabilidad",
        order: 10,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
        duration_seconds: 560,
        key_points: [
          "Cálculo e interpretación de la media aritmética, mediana (valor central ordenado) y moda (valor con mayor frecuencia).",
          "Medidas de dispersión básica: rango (máximo - mínimo), varianza y desviación estándar.",
          "Probabilidad clásica de Laplace: P(A) = casos favorables / casos posibles, y regla del producto para eventos independientes."
        ],
        pdf_resources: [
          {
            name: "Guia_Estadistica_Probabilidad_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Las calificaciones de un estudiante en 7 exámenes son: 8, 9, 6, 10, 8, 7, 8. ¿Cuáles son la media, mediana y moda respectivamente?",
            options: [
              "Media: 8, Mediana: 8, Moda: 8",
              "Media: 8.2, Mediana: 7, Moda: 8",
              "Media: 8, Mediana: 9, Moda: 7"
            ],
            correct_index: 0,
            explanation: "Suma = 56 ÷ 7 = 8 (media). Ordenados: 6, 7, 8, 8, 8, 9, 10. El elemento central es 8 (mediana). El número que más se repite es 8 (moda)."
          },
          {
            id: 2,
            question: "En una urna hay 5 canicas rojas, 4 azules y 3 verdes. Si se extrae una canica al azar, ¿cuál es la probabilidad de que NO sea azul?",
            options: [
              "2/3",
              "1/3",
              "3/4"
            ],
            correct_index: 0,
            explanation: "Total de canicas = 5 + 4 + 3 = 12. Canicas que no son azules = 5 rojas + 3 verdes = 8. Probabilidad = 8/12 = 2/3."
          }
        ]
      }
    ]
  },
  {
    id: "curso_comprension_lectora",
    title: "Comprensión Lectora EXANI-II 2026",
    description: "Dominio de las 3 subáreas del Ceneval: ámbito de estudio (textos científicos y académicos), ámbito literario (cuento, novela, poesía, ensayo) y ámbito de participación social (periodísticos, editoriales, normativos). Estrategias de lectura inferencial, síntesis, identificación de tesis y análisis crítico del discurso.",
    category: "Comprensión Lectora",
    areaKey: "comprension_lectora",
    area_id: 2,
    periodId: "p1",
    periodName: "Ciclo Intensivo Admisión 2026",
    price: 300,
    priceCurrency: "MXN",
    billingCycle: "Periodo del curso",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?auto=format&fit=crop&w=800&q=80",
    total_lessons: 9,
    duration_minutes: 80,
    is_published: true,
    lessons: [
      {
        id: "cl_101",
        course_id: "curso_comprension_lectora",
        title: "Lección 1: Estructura del Texto Científico y Argumentativo",
        module: "Módulo 1: Ámbito de Estudio",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        duration_seconds: 510,
        key_points: [
          "Identificación de las partes estructurales: introducción con planteamiento del problema, hipótesis/tesis, cuerpo argumentativo y conclusiones.",
          "Distinción entre premisas, evidencias experimentales y afirmaciones concluyentes.",
          "Reconocimiento de marcadores de certeza, duda y restricción en textos de divulgación científica."
        ],
        pdf_resources: [
          {
            name: "Guia_Textos_Cientificos_EXANI.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.9 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál de los siguientes enunciados representa una tesis y no una simple evidencia fáctica?",
            options: [
              "La implementación de energías renovables descentralizadas es la vía más viable para mitigar la pobreza energética en comunidades rurales.",
              "En 2023, la radiación solar promedio en la zona norte del país superó los 5.8 kWh por metro cuadrado al día.",
              "Los paneles solares fotovoltaicos convierten la luz solar en electricidad mediante semiconductores."
            ],
            correct_index: 0,
            explanation: "Una tesis es una postura o juicio debatible que requiere ser demostrada mediante argumentos. Las otras opciones son datos objetivos o descripciones técnicas."
          },
          {
            id: 2,
            question: "¿Cuál es la función principal de una conclusión en un artículo de divulgación científica?",
            options: [
              "Sintetizar los hallazgos principales y proyectar sus implicaciones o futuras líneas de investigación",
              "Introducir nuevos conceptos y variables no abordadas en el marco teórico",
              "Presentar una lista exhaustiva de citas bibliográficas de soporte"
            ],
            correct_index: 0,
            explanation: "La conclusión recapitula los argumentos y resultados clave sin introducir premisas inconexas, abriendo horizontes de aplicación o investigación."
          }
        ]
      },
      {
        id: "cl_102",
        course_id: "curso_comprension_lectora",
        title: "Lección 2: Ideas Principales, Secundarias y Propósito del Autor",
        module: "Módulo 1: Ámbito de Estudio",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        duration_seconds: 490,
        key_points: [
          "Técnicas de supresión y generalización para extraer la idea principal sin caer en distractores que solo repiten detalles secundarios.",
          "Función de las ideas secundarias: ejemplificar, contrastar, justificar o ampliar la idea central.",
          "Determinación del propósito comunicativo del emisor (informar, persuadir, refutar, advertir o instruir)."
        ],
        pdf_resources: [
          {
            name: "Estrategias_Idea_Principal_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "En un texto que describe los efectos del cambio climático en los arrecifes de coral y advierte sobre el colapso pesquero inminente si no se reducen emisiones, ¿cuál es el propósito primordial del autor?",
            options: [
              "Concientizar y persuadir al lector sobre la urgencia de adoptar medidas ecológicas vinculantes",
              "Ofrecer un manual taxonómico de las especies coralinas del mar Caribe",
              "Criticar exclusivamente el desarrollo turístico de las zonas costeras"
            ],
            correct_index: 0,
            explanation: "El propósito comunicativo trasciende la mera información; busca motivar una postura de acción ante la urgencia ambiental descrita."
          },
          {
            id: 2,
            question: "¿Cómo se distingue con seguridad una idea secundaria frente a la idea principal en un párrafo analítico?",
            options: [
              "Si se elimina la idea secundaria, el texto mantiene su sentido medular aunque pierde detalle o ejemplificación",
              "La idea secundaria siempre se localiza al principio del primer párrafo",
              "La idea secundaria nunca contiene cifras, fechas ni datos cuantitativos"
            ],
            correct_index: 0,
            explanation: "La prueba de supresión indica que la idea principal no puede eliminarse sin alterar o destruir la coherencia medular del fragmento."
          }
        ]
      },
      {
        id: "cl_103",
        course_id: "curso_comprension_lectora",
        title: "Lección 3: Inferencias y Conclusiones en Textos de Divulgación",
        module: "Módulo 1: Ámbito de Estudio",
        order: 3,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration_seconds: 520,
        key_points: [
          "Diferencia entre información explícita (literal) e información implícita (inferida a partir de premisas contextuales).",
          "Reglas de deducción lógica para responder preguntas inferenciales en el EXANI-II sin sobreinterpretar.",
          "Relaciones de causa-efecto, condición y consecuencia en textos explicativos."
        ],
        pdf_resources: [
          {
            name: "Guia_Lectura_Inferencial_EXANI.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.6 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Si el texto afirma: 'A pesar del incremento en el presupuesto educativo durante el último lustro, las pruebas estandarizadas de matemáticas no mostraron avances significativos en los estudiantes de secundaria', ¿qué se infiere válidamente?",
            options: [
              "Un mayor presupuesto económico no se traduce de manera automática en una mejora del aprendizaje académico",
              "Las matemáticas son una disciplina imposible de aprender para los estudiantes evaluados",
              "El gobierno debe retirar todo el presupuesto destinado al sistema educativo nacional"
            ],
            correct_index: 0,
            explanation: "La inferencia correcta parte estrictamente de la premisa: la inversión económica por sí sola no ha garantizado resultados pedagógicos cuantificables."
          },
          {
            id: 2,
            question: "¿Cuál es un error común al responder preguntas de inferencia en el examen Ceneval?",
            options: [
              "Elegir una opción que agrega supuestos o juicios personales no sustentados en el texto",
              "Buscar marcas textuales y conectores concesivos o causales",
              "Sintetizar la relación lógica entre dos párrafos contiguos"
            ],
            correct_index: 0,
            explanation: "La sobreinterpretación o sesgo personal es el distractor más recurrente en reactivos de lectura inferencial del Ceneval."
          }
        ]
      },
      {
        id: "cl_104",
        course_id: "curso_comprension_lectora",
        title: "Lección 4: Texto Narrativo: Conflicto, Personajes y Secuencia Temporal",
        module: "Módulo 2: Ámbito Literario",
        order: 4,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        duration_seconds: 500,
        key_points: [
          "Estructura narrativa: planteamiento, nudo, clímax y desenlace.",
          "Tipos de narrador (protagonista, testigo, omnisciente) y su impacto en la perspectiva del relato.",
          "Análisis de motivaciones de los personajes y rupturas temporales (analepsis / retrospectiva y prolepsis / anticipación)."
        ],
        pdf_resources: [
          {
            name: "Analisis_Texto_Narrativo_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.7 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "En un relato donde el narrador relata sucesos ocurridos a terceros, pero conoce los pensamientos íntimos y emociones de todos los protagonistas sin participar en la trama, ¿qué tipo de narrador interviene?",
            options: [
              "Narrador omnisciente",
              "Narrador testigo",
              "Narrador en primera persona protagonista"
            ],
            correct_index: 0,
            explanation: "El narrador omnisciente relata en tercera persona y domina la totalidad del universo psicológico y fáctico de los personajes."
          },
          {
            id: 2,
            question: "¿Qué elemento marca el momento de mayor tensión dramática y punto de quiebre en un texto narrativo?",
            options: [
              "El clímax",
              "El marco espaciotemporal inicial",
              "El epílogo"
            ],
            correct_index: 0,
            explanation: "El clímax es la cúspide emocional o dramática donde el conflicto alcanza su máxima intensidad antes de resolverse."
          }
        ]
      },
      {
        id: "cl_105",
        course_id: "curso_comprension_lectora",
        title: "Lección 5: Figuras Retóricas y Sentido Figurado",
        module: "Módulo 2: Ámbito Literario",
        order: 5,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
        duration_seconds: 480,
        key_points: [
          "Diferenciación entre lenguaje literal (denotativo) y lenguaje figurado (connotativo).",
          "Reconocimiento de figuras retóricas clave evaluadas por el Ceneval: metáfora, símil, hipérbole, prosopopeya y antítesis.",
          "Interpretación del tono del autor (nostálgico, satírico, reflexivo, sombrío o esperanzador)."
        ],
        pdf_resources: [
          {
            name: "Guia_Figuras_Retoricas_EXANI.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "En el verso: 'El viento de la noche susurraba secretos olvidados entre las ramas desnudas', ¿qué figura retórica se encuentra presente?",
            options: [
              "Prosopopeya (personificación)",
              "Hipérbole",
              "Oxímoron"
            ],
            correct_index: 0,
            explanation: "Se atribuyen cualidades humanas ('susurrar secretos') a un elemento inanimado como el viento, lo cual define a la prosopopeya."
          },
          {
            id: 2,
            question: "¿Cuál de las siguientes expresiones contiene un símil explícito?",
            options: [
              "Sus ojos brillaban como faros en medio de la niebla nocturna",
              "El río era una serpiente de plata atravesando el valle",
              "Lloró ríos de lágrimas durante tres semanas enteras"
            ],
            correct_index: 0,
            explanation: "El símil o comparación directa utiliza conectores comparativos evidentes como 'como', 'cual' o 'parecido a'."
          }
        ]
      },
      {
        id: "cl_106",
        course_id: "curso_comprension_lectora",
        title: "Lección 6: El Ensayo Literario y Juicios de Valor",
        module: "Módulo 2: Ámbito Literario",
        order: 6,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyBlazes.mp4",
        duration_seconds: 510,
        key_points: [
          "Características del ensayo: carácter reflexivo, rigor argumentativo combinado con estilo literario y libertad temática.",
          "Detección de la subjetividad reflexiva vs la objetividad factual.",
          "Identificación de juicios de valor éticos, estéticos o culturales expresados por el ensayista."
        ],
        pdf_resources: [
          {
            name: "Comprension_Ensayo_Literario.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.3 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Qué rasgo distingue fundamentalmente al ensayo literario de un reporte técnico de laboratorio?",
            options: [
              "El ensayo manifiesta la perspectiva crítica y la prosa estilística personal del autor frente al tema",
              "El ensayo carece totalmente de coherencia y secuencia argumentativa",
              "El ensayo se escribe exclusivamente en verso rimado"
            ],
            correct_index: 0,
            explanation: "El ensayo combina el rigor reflexivo con la sensibilidad literaria y la voz crítica del emisor."
          },
          {
            id: 2,
            question: "Cuando un autor señala: 'La belleza efímera del arte digital palidece frente a la solemnidad imperecedera del óleo clásico', está emitiendo:",
            options: [
              "Un juicio de valor estético subjetivo",
              "Un hecho experimental científicamente demostrado",
              "Una norma legal vinculante"
            ],
            correct_index: 0,
            explanation: "Se trata de una valoración estética que depende de la apreciación crítica personal del ensayista."
          }
        ]
      },
      {
        id: "cl_107",
        course_id: "curso_comprension_lectora",
        title: "Lección 7: Géneros Periodísticos Informativos: Noticia y Reportaje",
        module: "Módulo 3: Ámbito de Participación Social",
        order: 7,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
        duration_seconds: 500,
        key_points: [
          "Estructura de la noticia: pirámide invertida (titular, entradilla/lead, cuerpo y cierre) respondiendo a las preguntas clásicas (qué, quién, cuándo, dónde, cómo, por qué).",
          "Distinción entre hechos fácticos comprobables y declaraciones testimoniales de fuentes involucradas.",
          "Profundidad y contextualización en el reportaje periodístico respecto a la inmediatez de la nota informativa."
        ],
        pdf_resources: [
          {
            name: "Generos_Periodisticos_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿En qué sección de una noticia periodística bien estructurada se concentran los datos fundamentales del acontecimiento?",
            options: [
              "En la entradilla o lead",
              "En el último párrafo de la nota",
              "Únicamente en el pie de foto"
            ],
            correct_index: 0,
            explanation: "El lead o entradilla sintetiza inmediatamente los datos medulares (qué, quién, cuándo y dónde) según la regla de la pirámide invertida."
          },
          {
            id: 2,
            question: "¿Cuál de las siguientes afirmaciones periodísticas conserva un tono estrictamente objetivo?",
            options: [
              "El sismo de magnitud 6.2 se registró a las 03:15 horas con epicentro a 25 km al suroeste de la costa",
              "El temible movimiento telúrico causó un pánico totalmente justificado entre la valiente población",
              "Por desgracia, las autoridades no supieron cómo reaccionar ante tan lamentable catástrofe"
            ],
            correct_index: 0,
            explanation: "La opción contiene únicamente datos factuales comprobables, sin adjetivos valorativos ni juicios subjetivos."
          }
        ]
      },
      {
        id: "cl_108",
        course_id: "curso_comprension_lectora",
        title: "Lección 8: Textos de Opinión: Editorial, Columna y Falacias",
        module: "Módulo 3: Ámbito de Participación Social",
        order: 8,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
        duration_seconds: 530,
        key_points: [
          "Diferencia entre el editorial periodístico (postura institucional del diario, sin firma) y la columna de opinión (postura personal firmada por el columnista).",
          "Estrategias retóricas de persuasión: apelación a la autoridad, datos estadísticos y analogías.",
          "Detección de falacias comunes en textos argumentativos: ad hominem (ataque al emisor), generalización apresurada y falsa causa."
        ],
        pdf_resources: [
          {
            name: "Guia_Falacias_y_Textos_Opinion.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Un articulista argumenta: 'La propuesta del diputado sobre reforma energética no tiene validez porque él nunca estudió ingeniería ni tiene solvencia moral'. ¿Qué falacia lógica comete?",
            options: [
              "Falacia ad hominem",
              "Falacia de apelación al temor",
              "Falacia del hombre de paja"
            ],
            correct_index: 0,
            explanation: "Comete falacia ad hominem porque desacredita el argumento atacando las características de la persona en lugar de refutar sus argumentos técnicos."
          },
          {
            id: 2,
            question: "¿Cuál es la principal característica formal del editorial periodístico en un diario de circulación nacional?",
            options: [
              "Refleja la línea ideológica institucional del medio y no lleva firma individual de autor",
              "Debe ser escrito en primera persona del singular por el periodista más joven",
              "Contiene únicamente anuncios publicitarios y ofertas de empleo"
            ],
            correct_index: 0,
            explanation: "El editorial no se firma porque expresa la postura colectiva y oficial del medio de comunicación."
          }
        ]
      },
      {
        id: "cl_109",
        course_id: "curso_comprension_lectora",
        title: "Lección 9: Textos Normativos, Publicitarios y Discontinuos",
        module: "Módulo 3: Ámbito de Participación Social",
        order: 9,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackSeeTheWorld.mp4",
        duration_seconds: 510,
        key_points: [
          "Comprensión de textos normativos e instructivos: reglamentos, convocatorias, leyes y manuales de procedimiento.",
          "Análisis de textos discontinuos evaluados por el Ceneval: infografías, esquemas de flujo, tablas comparativas y gráficas.",
          "Lectura crítica de mensajes publicitarios: eslogan, destinatario meta y técnicas de persuasión comercial."
        ],
        pdf_resources: [
          {
            name: "Lectura_Textos_Discontinuos_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.8 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "En una convocatoria de admisión donde se estipula: 'Los aspirantes que no presenten su pase de ingreso impreso quedarán automáticamente excluidos sin excepción', ¿cuál es el carácter del enunciado?",
            options: [
              "Prescriptivo y excluyente de carácter obligatorio",
              "Opcional y meramente orientativo",
              "Informativo sin repercusión administrativa"
            ],
            correct_index: 0,
            explanation: "El texto normativo establece una condición estricta de cumplimiento vinculante cuyo desacato anula el derecho de participación."
          },
          {
            id: 2,
            question: "¿Cuál es el paso metodológico indispensable para interpretar correctamente una gráfica estadística en un texto discontinuo?",
            options: [
              "Identificar los ejes temáticos, unidades de medida y la relación entre las variables representadas",
              "Contar únicamente el número total de barras o líneas sin mirar las etiquetas",
              "Asumir que la barra más alta siempre representa el valor más favorable"
            ],
            correct_index: 0,
            explanation: "Para interpretar una gráfica se debe identificar qué representa cada eje (título, magnitudes y unidades) antes de extraer conclusiones analíticas."
          }
        ]
      }
    ]
  },
  {
    id: "curso_redaccion_indirecta",
    title: "Redacción Indirecta EXANI-II 2026",
    description: "Preparación especializada para los 30 reactivos de Redacción Indirecta del Ceneval. Abarca normativa ortográfica, acentuación gráfica y diacrítica, grafías dudosas, signos de puntuación, concordancia gramatical, eliminación de vicios del lenguaje, conectores textuales, cohesión, coherencia y adecuación al registro formal.",
    category: "Redacción Indirecta",
    areaKey: "redaccion_indirecta",
    area_id: 3,
    periodId: "p1",
    periodName: "Ciclo Intensivo Admisión 2026",
    price: 300,
    priceCurrency: "MXN",
    billingCycle: "Periodo del curso",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80",
    total_lessons: 9,
    duration_minutes: 80,
    is_published: true,
    lessons: [
      {
        id: "ri_101",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 1: Reglas de Acentuación y Tilde Diacrítica",
        module: "Módulo 1: Normativa Ortográfica y Puntuación",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
        duration_seconds: 490,
        key_points: [
          "Clasificación acentual por sílaba tónica: agudas (última), graves/llanas (penúltima), esdrújulas y sobresdrújulas.",
          "Diptongos, triptongos y ley del hiato acentual (vocal cerrada tónica + vocal abierta siempre se tildan, ej. raíz, país, día).",
          "Tilde diacrítica en monosílabos fundamentales: él/el, tú/tu, mí/mi, té/te, dé/de, sé/se, sí/si, más/mas y aún/aun."
        ],
        pdf_resources: [
          {
            name: "Compendio_Reglas_Acentuacion_RAE.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.3 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Seleccione la opción con acentuación gráfica impecable conforme a las normas de la RAE:",
            options: [
              "Él no se percató de que aún quedaba más café para mí en la cafetera.",
              "El no se percato de que aun quedaba mas café para mi en la cafetera.",
              "Él no se percató de que aun quedaba más café para mi en la cafetéra."
            ],
            correct_index: 0,
            explanation: "'Él' (pronombre), 'percató' (aguda en vocal), 'aún' (equivale a todavía), 'más' (cantidad) y 'mí' (pronombre preposicional) llevan tilde diacrítica y ortográfica obligatoria."
          },
          {
            id: 2,
            question: "¿En cuál de los siguientes enunciados la palabra 'si' debe escribirse CON tilde diacrítica?",
            options: [
              "El candidato respondió con un rotundo sí cuando se le preguntó sobre su compromiso.",
              "Si estudias con anticipación, obtendrás un excelente puntaje en el examen.",
              "La sonata para violín fue compuesta en si menor por el maestro."
            ],
            correct_index: 0,
            explanation: "'Sí' lleva tilde diacrítica cuando funciona como adverbio de afirmación o pronombre reflexivo ('volvió en sí'). No lleva tilde como conjunción condicional ('si estudias') ni como nota musical ('si menor')."
          }
        ]
      },
      {
        id: "ri_102",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 2: Grafías Problemáticas y Palabras Homófonas",
        module: "Módulo 1: Normativa Ortográfica y Puntuación",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4",
        duration_seconds: 480,
        key_points: [
          "Uso correcto de grafías dudosas: b/v, c/s/z/x, g/j, h intervocálica y ll/y.",
          "Distinción rigurosa de homófonos evaluados por Ceneval: hecho/echo, haber/a ver, tubo/tuvo, vaya/valla/baya, ay/hay/ahí.",
          "Palabras de escritura junta o separada: por qué, porque, porqué y por que; asimismo / así mismo."
        ],
        pdf_resources: [
          {
            name: "Guia_Grafias_Homofonos_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Complete la oración con las palabras correctas: 'No comprendo el _______ de su renuncia, _______ no asistió _______ la sesión explicativa'.",
            options: [
              "porqué / porque / a ver",
              "porque / por qué / haber",
              "por qué / porqué / a ver"
            ],
            correct_index: 0,
            explanation: "'Porqué' sustantivo (motivo o causa, con artículo), 'porque' conjunción causal explicativa (da la razón), y 'a ver' perífrasis de preposición + infinitivo del verbo ver."
          },
          {
            id: 2,
            question: "Seleccione el enunciado que utiliza correctamente la grafía de las palabras homófonas:",
            options: [
              "El doctor dijo que el paciente tuvo complicaciones cuando el tubo de oxígeno falló.",
              "El doctor dijo que el paciente tubo complicaciones cuando el tuvo de oxígeno falló.",
              "El doctor dijo que el paciente tuvo complicaciones cuando el tuvo de oxígeno fallo."
            ],
            correct_index: 0,
            explanation: "'Tuvo' es forma conjugada del verbo tener (con v); 'tubo' es el sustantivo que designa un cilindro hueco (con b)."
          }
        ]
      },
      {
        id: "ri_103",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 3: Signos de Puntuación: Coma, Punto y Coma, Dos Puntos",
        module: "Módulo 1: Normativa Ortográfica y Puntuación",
        order: 3,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
        duration_seconds: 520,
        key_points: [
          "Tipos de coma normativos: enumerativa, vocativa ('Estudiantes, presten atención'), hiperbática (alteración del orden sintáctico), incidental/explicativa y elíptica (sustituye un verbo omitido).",
          "Regla de oro: NUNCA colocar coma entre sujeto y predicado (coma criminal).",
          "Uso del punto y coma ante conectores de contraste en oraciones largas ('..., sin embargo, ...') y de dos puntos antes de citas o enumeraciones explicativas."
        ],
        pdf_resources: [
          {
            name: "Manual_Puntuacion_Normativa.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál de los siguientes enunciados presenta un uso correcto de la coma y no incurre en coma criminal?",
            options: [
              "Aunque las condiciones meteorológicas eran adversas, la tripulación zarpó a tiempo.",
              "Los aspirantes con mejores promedios de bachillerato, obtuvieron la beca de excelencia.",
              "El capitán del navío ordenó a los oficiales, que mantuvieran la calma."
            ],
            correct_index: 0,
            explanation: "La primera oración contiene una coma hiperbática correcta tras la subordinada circunstancial inicial. Las otras opciones separan indebidamente el sujeto de su verbo o el verbo de su objeto directo con una coma criminal."
          },
          {
            id: 2,
            question: "¿Cuál opción puntúa de forma canónica el uso de punto y coma ante un conector adversativo?",
            options: [
              "El equipo entrenó rigurosamente durante seis meses; sin embargo, no alcanzaron el podio.",
              "El equipo entrenó rigurosamente durante seis meses, sin embargo; no alcanzaron el podio.",
              "El equipo entrenó rigurosamente durante seis meses: sin embargo no alcanzaron el podio."
            ],
            correct_index: 0,
            explanation: "Cuando las proposiciones vinculadas por un conector adversativo son extensas o contienen comas internas, se coloca punto y coma antes del conector y coma posterior: '; sin embargo, '."
          }
        ]
      },
      {
        id: "ri_104",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 4: Concordancia Nominal y Verbal en Estructuras Complejas",
        module: "Módulo 2: Sintaxis, Concordancia y Cohesión",
        order: 4,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        duration_seconds: 510,
        key_points: [
          "Concordancia entre sujeto compuesto y verbo (núcleos coordinados exigen plural).",
          "Concordancia con sujetos colectivos y cuantitativos partitivos ('un grupo de', 'la mayoría de', 'el 20% de los estudiantes').",
          "Regla de oraciones impersonales con el verbo 'haber': siempre se conjuga en tercera persona del singular ('hubo problemas', 'había muchas personas', no *hubieron ni *habían)."
        ],
        pdf_resources: [
          {
            name: "Reglas_Concordancia_Gramatical.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.6 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Identifique la oración que cumple cabalmente con las normas de concordancia gramatical:",
            options: [
              "Hubo varios incidentes durante el simulacro, pero la comisión los resolvió eficazmente.",
              "Hubieron varios incidentes durante el simulacro, pero la comisión los resolvió eficazmente.",
              "Habían muchas dudas sobre la fecha de examen entre los alumnos convocados."
            ],
            correct_index: 0,
            explanation: "El verbo 'haber' en sentido existencial es impersonal y carece de sujeto; solo admite conjugación en 3.ª persona singular ('hubo', 'había', 'habrá'), nunca en plural."
          },
          {
            id: 2,
            question: "Seleccione la frase que concuerda adecuadamente en género y número:",
            options: [
              "El decano y la secretaria generales firmaron el acta respectiva.",
              "El decano y la secretaria general firmaron el acta respectivo.",
              "El decano y la secretaria generales firmaron el acta respectivo."
            ],
            correct_index: 0,
            explanation: "Cuando un adjetivo pospuesto califica a dos sustantivos singulares coordinados de distinto género, debe concordar en plural y género masculino o plural común: 'el decano y la secretaria generales firmaron el acta respectiva' ('acta' es sustantivo femenino con artículo 'el' por a tónica inicial, pero sus adjetivos van en femenino: 'respectiva')."
          }
        ]
      },
      {
        id: "ri_105",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 5: Vicios del Lenguaje: Queísmo, Dequeísmo y Solecismo",
        module: "Módulo 2: Sintaxis, Concordancia y Cohesión",
        order: 5,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        duration_seconds: 500,
        key_points: [
          "Técnica para detectar el dequeísmo y queísmo: reemplazar la cláusula subordinada por el pronombre 'eso' y formular la pregunta (¿de qué o qué?).",
          "Dequeísmo: añadir indebidamente 'de' antes de 'que' (*pienso de que -> pienso que).",
          "Queísmo: omitir indebidamente la preposición 'de' (*me acordé que -> me acordé de que).",
          "Solecismos comunes: errores de régimen preposicional (*a grosso modo -> grosso modo, *en base a -> con base en)."
        ],
        pdf_resources: [
          {
            name: "Vicios_del_Lenguaje_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál de las siguientes oraciones es gramaticalmente correcta y no presenta queísmo ni dequeísmo?",
            options: [
              "El catedrático nos convenció de que el proyecto requería mayor sustento bibliográfico.",
              "El catedrático nos convenció que el proyecto requería mayor sustento bibliográfico.",
              "El catedrático nos aseguró de que el proyecto requería mayor sustento bibliográfico."
            ],
            correct_index: 0,
            explanation: "El verbo 'convencer' exige la preposición de ('convencer a alguien de algo' -> nos convenció de eso). En cambio, 'asegurar' es transitivo directo ('asegurar algo' -> asegurar que, sin 'de')."
          },
          {
            id: 2,
            question: "Seleccione la locución preposicional correcta según la Real Academia Española:",
            options: [
              "Con base en los resultados del peritaje, se dictó la sentencia definitiva.",
              "En base a los resultados del peritaje, se dictó la sentencia definitiva.",
              "Bajo la base de los resultados del peritaje, se dictó la sentencia definitiva."
            ],
            correct_index: 0,
            explanation: "La locución correcta es 'con base en' o 'a partir de'. La construcción 'en base a' es un calco vicioso desaconsejado en el registro culto formal."
          }
        ]
      },
      {
        id: "ri_106",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 6: Conectores Discursivos y Marcadores Textuales",
        module: "Módulo 2: Sintaxis, Concordancia y Cohesión",
        order: 6,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4",
        duration_seconds: 480,
        key_points: [
          "Clasificación funcional de conectores: aditivos (además, asimismo), adversativos y concesivos (sin embargo, no obstante, a pesar de que), causales (ya que, puesto que) y consecutivos (por lo tanto, por ende, por consiguiente).",
          "Elección del enlace discursivo que preserva la intención lógica del párrafo.",
          "Errores por falsos conectores o uso redundante (*mas sin embargo)."
        ],
        pdf_resources: [
          {
            name: "Tabla_Conectores_Discursivos_Ceneval.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.2 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Elija el conector lógico que expresa relación de causa para completar el texto: 'El experimento falló en su última fase, _______ los técnicos no calibraron el sensor de temperatura oportunamente'.",
            options: [
              "puesto que",
              "por lo tanto",
              "a pesar de que"
            ],
            correct_index: 0,
            explanation: "'Puesto que' es una conjunción causal que introduce el motivo o causa del fallo experimental."
          },
          {
            id: 2,
            question: "¿Qué error de cohesión y redundancia léxica se detecta en la frase: 'El plan es excelente, mas sin embargo presenta riesgos'?",
            options: [
              "Uso pleonástico de dos conectores adversativos contiguos ('mas' y 'sin embargo')",
              "Falta de concordancia verbal entre sujeto y verbo",
              "Incorrección en la acentuación de 'embargo'"
            ],
            correct_index: 0,
            explanation: "'Mas' y 'sin embargo' son conectores adversativos sinónimos. Utilizarlos juntos constituye una redundancia pleonástica incorrecta en el registro formal."
          }
        ]
      },
      {
        id: "ri_107",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 7: Registro Lingüístico Formal y Precisión Léxica",
        module: "Módulo 3: Coherencia y Registro Formal",
        order: 7,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
        duration_seconds: 500,
        key_points: [
          "Identificación del registro formal académico frente al lenguaje coloquial, vulgarismos o modismos.",
          "Sustitución de verbos comodín ('hacer', 'tener', 'poner', 'echar') por verbos de máxima precisión léxica ('elaborar', 'poseer', 'instalar', 'proferir').",
          "Evitación de muletillas, ambigüedades semánticas y expresiones imprecisas."
        ],
        pdf_resources: [
          {
            name: "Precision_Lexica_Registro_Academico.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "¿Cuál opción sustituye el verbo comodín 'hacer' con la mayor precisión léxica y formalidad académica en: 'El comité hizo un nuevo reglamento'?",
            options: [
              "El comité redactó un nuevo reglamento institucional",
              "El comité puso en marcha un nuevo reglamento rápido",
              "El comité armó un nuevo reglamento institucional"
            ],
            correct_index: 0,
            explanation: "'Redactó' (o 'promulgó' / 'elaboró') aporta la máxima precisión semántica propia del contexto normativo formal, eliminando el comodín 'hizo'."
          },
          {
            id: 2,
            question: "Seleccione el enunciado que se apega estrictamente al registro formal requerido en un oficio institucional:",
            options: [
              "Por medio de la presente, solicito formalmente la revisión de las calificaciones emitidas.",
              "Le mando este escrito para ver si le puede echar un ojo a mis calificaciones del examen.",
              "Ojalá me pueda checar las notas porque siento que hubo alguna confusión rara."
            ],
            correct_index: 0,
            explanation: "La primera opción emplea fórmulas institucionales de cortesía, vocabulario preciso y ausencia de coloquialismos."
          }
        ]
      },
      {
        id: "ri_108",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 8: Estructura y Progresión Temática del Párrafo",
        module: "Módulo 3: Coherencia y Registro Formal",
        order: 8,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
        duration_seconds: 520,
        key_points: [
          "Unidad y coherencia: cada párrafo debe desarrollar una sola idea principal mediante ideas secundarias articuladas.",
          "Progresión temática: de lo conocido (tema) a la información nueva (rema).",
          "Ordenación lógica de enunciados: cronológico, deductivo (de lo general a lo particular) e inductivo."
        ],
        pdf_resources: [
          {
            name: "Coherencia_y_Estructura_Parrafo.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.6 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Ordene lógicamente las oraciones para integrar un párrafo coherente: 1. Por ello, los expertos recomiendan moderar su consumo. 2. Las bebidas energizantes contienen altas dosis de cafeína y taurina. 3. Dicha combinación puede elevar la presión arterial y generar taquicardia.",
            options: [
              "2, 3, 1",
              "1, 2, 3",
              "3, 1, 2"
            ],
            correct_index: 0,
            explanation: "La oración 2 introduce el tema (contenido de las bebidas), la oración 3 describe el efecto adverso (taquicardia) y la oración 1 concluye con la recomendación médica mediante el conector consecutivo 'Por ello'."
          },
          {
            id: 2,
            question: "¿Cuál enunciado debe eliminarse de un texto sobre la fotosíntesis por romper la unidad temática?",
            options: [
              "La celulosa es también la principal materia prima utilizada en la industria textil del algodón.",
              "Durante la fase luminosa, los cloroplastos capturan energía solar para sintetizar ATP.",
              "La clorofila absorbe predominantemente longitudes de onda del espectro azul y rojo."
            ],
            correct_index: 0,
            explanation: "Mencionar el uso industrial textil de la celulosa desvía el enfoque biológico de los mecanismos bioquímicos de la fotosíntesis."
          }
        ]
      },
      {
        id: "ri_109",
        course_id: "curso_redaccion_indirecta",
        title: "Lección 9: Corrección Estilística y Reescritura Ceneval",
        module: "Módulo 3: Coherencia y Registro Formal",
        order: 9,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyBlazes.mp4",
        duration_seconds: 530,
        key_points: [
          "Metodología para resolver reactivos de reescritura en Redacción Indirecta del Ceneval.",
          "Eliminación de anfibologías (doble sentido por mala colocación de modificadores o posesivos).",
          "Detección simultánea de concordancia, acentuación, puntuación y economía lingüística en opciones de examen."
        ],
        pdf_resources: [
          {
            name: "Simulador_Reactivos_Redaccion_Indirecta.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.9 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Seleccione el párrafo que no presenta errores de ambigüedad, ortografía ni concordancia:",
            options: [
              "El médico examinó al paciente con el estetoscopio digital que había adquirido recientemente en el congreso.",
              "El médico examinó al paciente con su camisa desabrochada y se fue rápidamente.",
              "El medico examino al paciente con el estetoscopio que habian comprado ellos."
            ],
            correct_index: 0,
            explanation: "La primera opción especifica con claridad quién poseía el instrumento y no genera anfibología sintáctica ni errores de tilde."
          },
          {
            id: 2,
            question: "¿Cuál versión reescrita mejora sustancialmente la claridad y economía verbal de: 'En lo que respecta a la totalidad de los miembros integrantes de la asamblea, ellos decidieron de manera unánime proceder a postergar la votación'?",
            options: [
              "La asamblea decidió unánimemente postergar la votación.",
              "En cuanto a todos los miembros de la asamblea decidieron postergarla.",
              "La totalidad unánime de los integrantes postergó para después la votación."
            ],
            correct_index: 0,
            explanation: "Elimina circunloquios y redundancias ('totalidad de los miembros integrantes', 'decidieron de manera unánime proceder a postergar') sintetizando en prosa concisa, directa y elegante."
          }
        ]
      }
    ]
  },
  {
    id: "curso_ingles_exani",
    title: "Inglés Diagnóstico EXANI-II (Nivel B1 MCER)",
    description: "Preparación para la sección diagnóstica de 30 reactivos de Inglés del EXANI-II (nivel B1 del Marco Común Europeo). Comprende técnicas de lectura de artículos académicos y culturales, contrastes de tiempos verbales (Simple Past vs Present Perfect), modales, oraciones condicionales, voz pasiva, conectores y vocabulario contextual.",
    category: "Inglés",
    areaKey: "ingles",
    area_id: 4,
    periodId: "p1",
    periodName: "Ciclo Intensivo Admisión 2026",
    price: 300,
    priceCurrency: "MXN",
    billingCycle: "Periodo del curso",
    stripeUrl: "https://buy.stripe.com/4gMaEX9qg0u63Jo5jb73G08",
    thumbnail: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?auto=format&fit=crop&w=800&q=80",
    total_lessons: 8,
    duration_minutes: 70,
    is_published: true,
    lessons: [
      {
        id: "ing_101",
        course_id: "curso_ingles_exani",
        title: "Lección 1: Reading Skills: Skimming, Scanning & Context Clues",
        module: "Módulo 1: Reading Comprehension",
        order: 1,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
        duration_seconds: 460,
        key_points: [
          "Skimming: rapid reading to extract the general overview and layout of an academic article.",
          "Scanning: searching for specific numbers, dates, proper names, or scientific keywords.",
          "Inferring the meaning of unfamiliar vocabulary using surrounding syntax, prefixes, and suffixes."
        ],
        pdf_resources: [
          {
            name: "Guia_Ingles_B1_Reading_Strategies.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.6 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Read the excerpt: 'Marine biologists have noticed an unprecedented decline in coral reefs due to rising sea temperatures.' What does the word 'unprecedented' mean in this context?",
            options: [
              "Never experienced or seen before in recorded history",
              "Completely expected and predictable",
              "Slightly beneficial for surrounding species"
            ],
            correct_index: 0,
            explanation: "The prefix 'un-' (not) + 'precedent' (previous instance) indicates an event that has never occurred or been witnessed before."
          },
          {
            id: 2,
            question: "Which reading technique is best suited when an exam item asks: 'In what year did the researcher publish his second patent?'",
            options: [
              "Scanning specifically for four-digit numerals and the word 'patent'",
              "Skimming every paragraph from beginning to end without stopping",
              "Translating the whole passage word-by-word into Spanish"
            ],
            correct_index: 0,
            explanation: "Scanning allows the reader to quickly locate specific information (like dates or numbers) without reading the entire text."
          }
        ]
      },
      {
        id: "ing_102",
        course_id: "curso_ingles_exani",
        title: "Lección 2: Main Idea, Purpose & Text Organization",
        module: "Módulo 1: Reading Comprehension",
        order: 2,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
        duration_seconds: 480,
        key_points: [
          "Identifying topic sentences within introductory and concluding paragraphs.",
          "Distinguishing the author's purpose: to describe, to argue, to critique, or to inform.",
          "Understanding common text structures: problem-solution, cause-effect, and chronological comparison."
        ],
        pdf_resources: [
          {
            name: "Text_Organization_Author_Purpose_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "What is the primary purpose of a passage that outlines the history of space exploration and compares Soviet and American milestones?",
            options: [
              "To inform the reader about key historical events and competitive advancements in space travel",
              "To persuade readers to enlist in an aerospace engineering academy",
              "To criticize the excessive financial cost of satellite technology"
            ],
            correct_index: 0,
            explanation: "The passage presents factual historical milestones and comparative data in an informative tone."
          },
          {
            id: 2,
            question: "In standard B1 English reading passages, where is the main idea usually introduced?",
            options: [
              "In the opening topic sentence of the introduction",
              "Hidden exclusively inside a footnote",
              "Only in the last three words of the text"
            ],
            correct_index: 0,
            explanation: "Most expository passages present their central thesis in the topic sentence of the opening paragraph."
          }
        ]
      },
      {
        id: "ing_103",
        course_id: "curso_ingles_exani",
        title: "Lección 3: Detailed Comprehension & Factual Statements",
        module: "Módulo 1: Reading Comprehension",
        order: 3,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackSeeTheWorld.mp4",
        duration_seconds: 470,
        key_points: [
          "Evaluating True/False/Not Given reading comprehension statements.",
          "Spotting deceptive distractor options that use identical words from the text but contradict the actual meaning.",
          "Synthesizing quantitative data and visual tables accompanying reading texts."
        ],
        pdf_resources: [
          {
            name: "Factual_Reading_Practice_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Text: 'Although several candidates applied for the scholarship, only two met all academic qualifications.' Which statement is true according to the text?",
            options: [
              "Only a couple of candidates satisfied the full set of requirements.",
              "All applicants were granted the prestigious scholarship.",
              "Nobody was qualified enough to receive the award."
            ],
            correct_index: 0,
            explanation: "'Only two met all academic qualifications' directly means that only a couple of candidates satisfied the criteria."
          },
          {
            id: 2,
            question: "When evaluating factual statements in the EXANI-II English section, what should you verify first?",
            options: [
              "Whether the statement matches the actual evidence stated in the passage without assumptions",
              "Whether the statement sounds like something you personally agree with",
              "Whether the statement is written in present continuous tense"
            ],
            correct_index: 0,
            explanation: "Factual answers must be grounded strictly in the provided text, avoiding subjective personal opinions."
          }
        ]
      },
      {
        id: "ing_104",
        course_id: "curso_ingles_exani",
        title: "Lección 4: Verb Tenses: Present Perfect vs Simple Past",
        module: "Módulo 2: Grammar Systems & Structures",
        order: 4,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4",
        duration_seconds: 520,
        key_points: [
          "Simple Past: completed actions at a definite time in the past (yesterday, in 2019, 3 years ago).",
          "Present Perfect: actions connected to the present, life experiences, or ongoing situations (since, for, already, yet, ever, never).",
          "Past Continuous (was/were + -ing) contrasted with Simple Past for interrupted actions ('I was studying when the phone rang')."
        ],
        pdf_resources: [
          {
            name: "Tenses_Comparison_Chart_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.3 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Choose the correct verbal form: 'She ________ in this naval research laboratory for five years, and she loves her current position.'",
            options: [
              "has worked",
              "worked",
              "is working yesterday"
            ],
            correct_index: 0,
            explanation: "'For five years' + still working there right now requires the Present Perfect tense ('has worked') to indicate an action continuing into the present."
          },
          {
            id: 2,
            question: "Choose the sentence that correctly uses the Simple Past with a specific past time marker:",
            options: [
              "The expedition arrived in Antarctica two months ago.",
              "The expedition has arrived in Antarctica two months ago.",
              "The expedition arrives in Antarctica two months ago."
            ],
            correct_index: 0,
            explanation: "Specific completed time markers like 'two months ago' require Simple Past ('arrived'), never Present Perfect."
          }
        ]
      },
      {
        id: "ing_105",
        course_id: "curso_ingles_exani",
        title: "Lección 5: Modal Verbs: Obligation, Permission & Deduction",
        module: "Módulo 2: Grammar Systems & Structures",
        order: 5,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4",
        duration_seconds: 490,
        key_points: [
          "Obligation and necessity: must (internal rule/strong) vs have to (external rule/institutional).",
          "Prohibition: mustn't vs lack of necessity: don't have to.",
          "Advice: should / ought to. Possibility and deduction: can, could, may, might."
        ],
        pdf_resources: [
          {
            name: "Modal_Verbs_Usage_Guide_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Which sentence expresses a strict institutional prohibition in an exam room?",
            options: [
              "Candidates must not use unauthorized electronic gadgets during the examination.",
              "Candidates don't have to bring their calculators if they don't want to.",
              "Candidates should bring water if they feel thirsty."
            ],
            correct_index: 0,
            explanation: "'Must not' expresses strict formal prohibition. 'Don't have to' merely indicates an optional action."
          },
          {
            id: 2,
            question: "Complete the sentence expressing logical deduction: 'He has been studying for 10 hours straight without taking a break. He ________ be exhausted.'",
            options: [
              "must",
              "can't",
              "shouldn't"
            ],
            correct_index: 0,
            explanation: "'Must' is used for positive logical deduction when we are sure of a conclusion based on strong evidence."
          }
        ]
      },
      {
        id: "ing_106",
        course_id: "curso_ingles_exani",
        title: "Lección 6: Conditionals: Zero, First & Second",
        module: "Módulo 2: Grammar Systems & Structures",
        order: 6,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4",
        duration_seconds: 510,
        key_points: [
          "Zero Conditional: universal truths and scientific facts (If + present simple, present simple).",
          "First Conditional: realistic future possibilities (If + present simple, will + base verb).",
          "Second Conditional: hypothetical or unreal situations (If + past simple, would + base verb)."
        ],
        pdf_resources: [
          {
            name: "Conditionals_Rules_and_Examples_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.5 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Select the sentence that correctly structures a First Conditional prediction:",
            options: [
              "If you prepare systematically every day, you will achieve a competitive score.",
              "If you will prepare systematically every day, you achieve a competitive score.",
              "If you prepared systematically every day, you will achieve a competitive score."
            ],
            correct_index: 0,
            explanation: "The 'if' clause takes the present simple ('prepare'), and the result clause takes 'will' + base verb ('will achieve')."
          },
          {
            id: 2,
            question: "Choose the correct option for a hypothetical scenario: 'If they ________ more funding, they would purchase advanced navigational equipment.'",
            options: [
              "had",
              "have",
              "will have"
            ],
            correct_index: 0,
            explanation: "Second conditional: If + past simple ('had'), would + base verb ('would purchase')."
          }
        ]
      },
      {
        id: "ing_107",
        course_id: "curso_ingles_exani",
        title: "Lección 7: Passive Voice in Academic & Factual Texts",
        module: "Módulo 2: Grammar Systems & Structures",
        order: 7,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
        duration_seconds: 500,
        key_points: [
          "Formula: Subject + verb to be (in corresponding tense) + Past Participle.",
          "Present Simple Passive: am/is/are + participle ('English is spoken worldwide').",
          "Past Simple Passive: was/were + participle ('The treaty was signed in 1945').",
          "Why passive is used in academic texts: to focus on the action/result rather than the agent."
        ],
        pdf_resources: [
          {
            name: "Passive_Voice_Formulas_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.3 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Convert the following sentence to Passive Voice: 'Alexander Fleming discovered penicillin in 1928.'",
            options: [
              "Penicillin was discovered by Alexander Fleming in 1928.",
              "Penicillin is discovered by Alexander Fleming in 1928.",
              "Penicillin had been discovering by Alexander Fleming in 1928."
            ],
            correct_index: 0,
            explanation: "The original sentence is in Past Simple ('discovered'). Its passive equivalent uses 'was' + past participle: 'was discovered'."
          },
          {
            id: 2,
            question: "Complete the academic description: 'Annual statistical reports ________ by the administration every December.'",
            options: [
              "are published",
              "is published",
              "are publishing"
            ],
            correct_index: 0,
            explanation: "'Reports' is plural, so we use 'are' + past participle 'published'."
          }
        ]
      },
      {
        id: "ing_108",
        course_id: "curso_ingles_exani",
        title: "Lección 8: Academic Connectors, Prepositions & Collocations",
        module: "Módulo 3: Vocabulary & Discourse",
        order: 8,
        video_url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4",
        duration_seconds: 480,
        key_points: [
          "Contrast connectors: however, although, despite / in spite of (+ noun/gerund).",
          "Cause and effect connectors: therefore, consequently, because of, as a result.",
          "Dependent prepositions and common collocations evaluated in B1 tests (interested in, capable of, depend on, apply for)."
        ],
        pdf_resources: [
          {
            name: "Linking_Words_and_Collocations_B1.pdf",
            url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
            size: "1.4 MB"
          }
        ],
        quiz: [
          {
            id: 1,
            question: "Choose the correct connector: '________ the severe storm warnings, the vessel managed to reach the port safely.'",
            options: [
              "Despite",
              "Although",
              "However"
            ],
            correct_index: 0,
            explanation: "'Despite' is followed directly by a noun phrase ('the severe storm warnings'). 'Although' would require a full clause with subject and verb."
          },
          {
            id: 2,
            question: "Select the sentence with the correct dependent preposition:",
            options: [
              "All naval cadets are capable of solving complex navigational problems under pressure.",
              "All naval cadets are capable in solving complex navigational problems under pressure.",
              "All naval cadets are capable with solving complex navigational problems under pressure."
            ],
            correct_index: 0,
            explanation: "The adjective 'capable' collocates strictly with the preposition 'of' followed by a gerund ('capable of solving')."
          }
        ]
      }
    ]
  }
];

export const COURSES_DATA = RAW_COURSES_DATA.map((course) => {
  const theoryMap =
    course.id === 'curso_pensamiento_matematico' ? PENSAMIENTO_MATEMATICO_THEORY :
    course.id === 'curso_comprension_lectora' ? COMPRENSION_LECTORA_THEORY :
    course.id === 'curso_redaccion_indirecta' ? REDACCION_INDIRECTA_THEORY :
    course.id === 'curso_ingles_diagnostico' ? INGLES_THEORY : {};

  return {
    ...course,
    lessons: (course.lessons || []).map((lesson) => ({
      ...lesson,
      theory: theoryMap[lesson.id] || null,
    })),
  };
});
